import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";

export default function Bookshop() {
  const { resolved } = useSettings();
  const [message, setMessage] = useState(resolved.bagMessage);
  const [title, setTitle] = useState(resolved.bookshopTitle);

  useEffect(() => {
    setMessage(resolved.bagMessage);
    setTitle(resolved.bookshopTitle);
  }, [resolved.bagMessage, resolved.bookshopTitle]);

  return (
    <section
      id="knjizara"
      data-testid="bookshop-section"
      className="relative py-24 lg:py-32 bg-gradient-to-b from-red-50/40 to-white overflow-hidden"
    >
      {/* decorative shapes */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-red-100 rounded-full blur-3xl opacity-50" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-red-50 rounded-full blur-3xl opacity-40" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-[#D32F2F] uppercase tracking-[0.25em] text-xs font-semibold mb-3">
            Knjižara MOBY SHOP
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-neutral-900"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            {title}
          </h2>
        </div>

        {/* Mascot + Speech bubble */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="relative order-2 lg:order-1"
          >
            {/* [USER] MASKOTA TORBA: zamjenjuje se preko Admin panela */}
            <div className="relative aspect-square max-w-md mx-auto">
              <div className="absolute inset-4 bg-[#D32F2F] rounded-[40%_60%_55%_45%/55%_45%_55%_45%] opacity-90 animate-pulse" />
              {resolved.bagMascot ? (
                <img
                  src={resolved.bagMascot}
                  alt="Maskota torba"
                  className="absolute inset-0 w-full h-full object-cover rounded-[40%_60%_55%_45%/55%_45%_55%_45%] shadow-2xl shadow-red-300"
                />
              ) : (
                <div className="absolute inset-0 grid place-items-center rounded-[40%_60%_55%_45%/55%_45%_55%_45%] bg-gradient-to-br from-[#D32F2F] to-[#8b1414] shadow-2xl shadow-red-300">
                  <div className="text-white text-8xl" role="img" aria-label="Torba">🎒</div>
                </div>
              )}
              {/* Floating sparkle dots */}
              <div className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full shadow-lg grid place-items-center text-2xl">
                ✏️
              </div>
              <div className="absolute -bottom-4 -left-2 w-14 h-14 bg-[#D32F2F] rounded-full shadow-lg grid place-items-center text-2xl">
                📚
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="order-1 lg:order-2"
          >
            <div className="speech-bubble shadow-xl">
              <div className="text-xs uppercase tracking-[0.2em] text-[#D32F2F] font-bold mb-3">
                🎒 Torba kaže:
              </div>
              <p className="text-xl lg:text-2xl text-neutral-800 leading-relaxed font-medium">
                <em>&bdquo;{message}&ldquo;</em>
              </p>
              <p className="text-neutral-600 mt-4 leading-relaxed">
                U našoj knjižari pronaći ćete <strong>školski pribor</strong>, <strong>pernice</strong>,
                <strong> torbe</strong>, <strong>bilježnice</strong>, <strong>udžbenike</strong> i
                još mnogo toga — sve na jednom mjestu, po pristupačnim cijenama.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["Pernice", "Torbe", "Bilježnice", "Pribor", "Knjige"].map((t) => (
                  <span
                    key={t}
                    className="px-4 py-1.5 bg-white border border-[#D32F2F]/30 text-[#D32F2F] rounded-full text-sm font-medium"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <a
                href="#proizvodi"
                data-testid="bookshop-cta"
                className="mt-6 inline-flex items-center gap-2 bg-[#D32F2F] hover:bg-[#B71C1C] text-white px-6 py-3 rounded-full font-semibold transition-colors"
              >
                Pogledaj artikle knjižare →
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
